<template>
  <button
    type="button"
    v-bind="$attrs"
    class="
      relative
      inline-block
      w-full
      rounded-full
      uppercase
      px-0
      pt-[.1rem]
      pb-[.2rem]
      border-1px
      transition-colors
      duration-300
      text-5.5 text-center
      font-semibold
      focus:outline-none
      disabled:cursor-not-allowed
    "
    :class="{
      'text-blue-900 bg-yellow border-yellow hover:bg-yellow hover:border-yellow':
        selected,
      'text-gray border-gray bg-transparent cursor-not-allowed': disabled,
      'text-blue-900 border-blue-900 hover:bg-yellow hover:border-yellow':
        !selected && !disabled
    }"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
